import React, { useState } from "react";
import { Edit, Delete, Security, SupervisorAccount, Person, Search } from "@mui/icons-material";

const roleIcons = {
  Admin: <Security style={{ color: "#1976d2" }} />,
  Editor: <SupervisorAccount style={{ color: "#9c27b0" }} />,
  Owner: <Person style={{ color: "#2e7d32" }} />,
};

const roleColors = {
  Admin: "#e3f2fd",
  Editor: "#f3e5f5",
  Owner: "#e8f5e9",
};

const UserList = ({ users, onEdit, onDelete, isOwner }) => {
  const [search, setSearch] = useState("");
  const [roleFilter, setRoleFilter] = useState("");

  const filteredUsers = users.filter((user) => {
    return (
      (user.displayName.toLowerCase().includes(search.toLowerCase()) ||
        user.email.toLowerCase().includes(search.toLowerCase())) &&
      (roleFilter ? user.roles.includes(roleFilter) : true)
    );
  });

  return (
    <div style={{ padding: 16 }}>
      {/* Search and Filter */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 12, marginBottom: 16 }}>
        <div style={{ flexGrow: 1 }}>
          <input
            type="text"
            placeholder="Search by name or email"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              width: "100%",
              padding: "8px 12px",
              borderRadius: 6,
              border: "1px solid #ccc",
              fontSize: 14,
            }}
          />
        </div>
        <div>
          <select
            value={roleFilter}
            onChange={(e) => setRoleFilter(e.target.value)}
            style={{
              padding: "8px 12px",
              borderRadius: 6,
              border: "1px solid #ccc",
              fontSize: 14,
            }}
          >
            <option value="">All Roles</option>
            <option value="Admin">Admin</option>
            <option value="Editor">Editor</option>
            <option value="Owner">Owner</option>
          </select>
        </div>
      </div>

      {/* Table Header */}
      <div style={{ display: "flex", fontWeight: "bold", padding: "12px 8px", borderBottom: "2px solid #ddd" }}>
        <div style={{ flex: 2 }}>Name</div>
        <div style={{ flex: 2 }}>Email</div>
        <div style={{ flex: 2 }}>Role(s)</div>
        <div style={{ flex: 1, textAlign: "right" }}>Actions</div>
      </div>

      {/* Table Body */}
      {filteredUsers.length > 0 ? (
        filteredUsers.map((user) => (
          <div
            key={user.id}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "12px 8px",
              borderBottom: "1px solid #eee",
            }}
          >
            <div style={{ flex: 2 }}>{user.displayName}</div>
            <div style={{ flex: 2 }}>{user.email}</div>
            <div style={{ flex: 2, display: "flex", flexWrap: "wrap", gap: 6 }}>
              {user.roles.map((role) => (
                <div
                  key={role}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: roleColors[role] || "#f0f0f0",
                    borderRadius: 12,
                    padding: "4px 8px",
                    fontSize: 12,
                  }}
                >
                  {roleIcons[role]} <span style={{ marginLeft: 4 }}>{role}</span>
                </div>
              ))}
            </div>
            <div style={{ flex: 1, textAlign: "right" }}>
              <button
                onClick={() => onEdit(user)}
                style={{
                  marginRight: 8,
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                }}
              >
                <Edit style={{ color: "#1976d2" }} />
              </button>
              <button
                onClick={() => onDelete(user.id)}
                disabled={isOwner && user.id === JSON.parse(localStorage.getItem("user")).id}
                style={{
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  opacity:
                    isOwner &&
                    user.id === JSON.parse(localStorage.getItem("user")).id
                      ? 0.5
                      : 1,
                }}
              >
                <Delete style={{ color: "#d32f2f" }} />
              </button>
            </div>
          </div>
        ))
      ) : (
        <div style={{ padding: 24, textAlign: "center", color: "#999" }}>
          No users found
        </div>
      )}
    </div>
  );
};

export default UserList;
